import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

interface UseCreateResourceCategoryParams {
  onSuccess?: () => void
  onError?: () => void
}

export interface CreateResourceCategoryPayload {
  name: string
  displayOrder?: number
}

export const useCreateResourceCategory = ({
  onSuccess,
  onError,
}: UseCreateResourceCategoryParams = {}) => {
  const queryClient = useQueryClient()
  const post = useTypedApiClient({
    path: '/admin/resources/categories',
    method: 'post',
  })

  return useMutation({
    mutationKey: ['/admin/resources/categories', 'create'],
    mutationFn: async (payload: CreateResourceCategoryPayload) => {
      const { data } = await post(payload)

      return data
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['/admin/resources/categories'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['/admin/resources'],
        }),
      ])

      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })
}
